import React, { useState, useEffect, } from 'react';
import { useParams, useLocation, useNavigate } from 'react-router-dom';
import { Stack, Button, Box, Grid, Card, CardContent, CardActions, Paper, CircularProgress, Popover, Typography, Divider, MenuItem } from '@mui/material';
import client from '../common/client';

const FigmaCallback = props => {
    const navigate = useNavigate()
    const location = useLocation()
    const {path} = useParams()
    
    /**
     *  File content (scopes: files:read): Read files, projects, users, versions, comments, components & styles, and webhooks.
        Variables (scopes: file_variables:read, file_variables:write): Read and write to variables in Figma file. Note: this is only available to members in Enterprise organizations.
        Comments (scopes: file_comments:write): Post and delete comments and comment reactions in files.
        Dev resources (scopes: file_dev_resources:read, file_dev_resources:write): Read and write to dev resources in files.
        Webhooks (scopes: webhooks:write): Create and manage webhooks.
     */
    useEffect(() => {
        const search = location.search;
        console.log('location', location)
        const query = new URLSearchParams(search)
        const code = query.get('code')
        const state = query.get('state')
        client.request_post(`/figma/login/callback`, {code, state}).then(res => {
            if(res && res.r)
                navigate('/ide')
        })
    }, [location])

    return (
        <Box sx={{ width:'100vw', height:'100vh', maxHeight:'100vh', overflow: 'hidden'}}>
           Consturcting Figma account connection...
        </Box>
    );
};

export default FigmaCallback;
